export const args = {
    minimumValue: 30,
    maximumValue: 100,
    step: 10,
    slideOnTap: false,
    value: 0,
};
export const argTypes = {};
